/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as NotificationDefs from './defs.defs.js'

const $nsid = 'app.bsky.notification.getPreferences'

export { $nsid }

/** Get notification-related preferences for an account. Requires auth. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    preferences: l.ref<NotificationDefs.Preferences>(
      (() => NotificationDefs.preferences) as any,
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
